import { CalendarRange, X } from "lucide-react";

const mask = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 8);
  if (d.length > 4) return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
  if (d.length > 2) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return d;
};

// "mm/dd/yyyy" -> "yyyy-mm-dd"; "" when empty; null when incomplete/invalid.
export const usToIso = (s) => {
  if (!s) return "";
  const m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  const [, mm, dd, yyyy] = m;
  const dt = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  if (dt.getFullYear() !== Number(yyyy) || dt.getMonth() !== Number(mm) - 1 || dt.getDate() !== Number(dd)) return null;
  return `${yyyy}-${mm}-${dd}`;
};

const DateBox = ({ label, value, onChange, testid }) => {
  const invalid = value && usToIso(value) === null && value.length === 10;
  return (
    <label className="flex items-center gap-2">
      <span className="text-xs uppercase tracking-widest text-[var(--ll-ink-soft)]">{label}</span>
      <input
        type="text"
        inputMode="numeric"
        placeholder="mm/dd/yyyy"
        value={value}
        onChange={(e) => onChange(mask(e.target.value))}
        data-testid={testid}
        className="px-3 py-2 border bg-white text-sm font-mono-fin w-[130px]"
        style={{ borderColor: invalid ? "var(--ll-error)" : "var(--ll-border)" }}
      />
    </label>
  );
};

export default function ReconDateRange({ start, end, onStart, onEnd, error }) {
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="recon-date-range">
      <CalendarRange size={16} className="opacity-60" />
      <DateBox label="Beginning" value={start} onChange={onStart} testid="recon-start-date" />
      <DateBox label="Ending" value={end} onChange={onEnd} testid="recon-end-date" />
      {(start || end) && (
        <button
          type="button"
          onClick={() => { onStart(""); onEnd(""); }}
          data-testid="recon-date-clear"
          className="inline-flex items-center gap-1 text-xs px-2 py-1.5 border hover:bg-[var(--ll-mint)] transition-colors"
          style={{ borderColor: "var(--ll-border)" }}
        >
          <X size={11} /> Clear dates
        </button>
      )}
      {error && <span className="text-xs text-[var(--ll-error)]" data-testid="recon-date-error">{error}</span>}
    </div>
  );
}
